require('/opt/odin/app/frontend/pages/guides/components/v2_journey/index.module.scss');module.exports = "../../app/cells/pages/guides/v2_journey/show.erb";